import React, { useMemo } from "react";
import { SunIcon } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import { Bots } from "@/interfaces/enums";

function EmptyChat({
  onExampleClick,
  bot,
  botName,
}: {
  bot: Bots;
  botName: string;
  onExampleClick: (text: string) => void;
}) {
  const { t } = useTranslation("copilot");

  const Examples = useMemo(() => {
    if (bot === Bots.rockBot)
      return [t("EXAML_QA_1"), t("EXAML_QA_2"), t("EXAML_QA_3")];

    return [t("EXAML_QA_4"), t("EXAML_QA_5"), t("EXAML_QA_6")];
  }, [bot, t]);

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex flex-1 items-center justify-center">
        <span className=" text-2xl font-semibold text-[#B9C3D6]">
          Welcome to {botName}.
        </span>
      </div>
      <div className="flex w-full flex-col items-center pb-4 text-[#757575]">
        <div className="mb-4 flex flex-col items-center pb-1">
          <SunIcon size={36} className="mb-2" />
          <div>{t("example")}</div>
        </div>
        <div className="w-full px-4">
          {Examples.map((val, idx) => (
            <motion.div
              animate={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 20 }}
              transition={{ delay: idx * 0.1 }}
              key={idx}
            >
              <div
                className="mb-4 w-full rounded-md bg-white px-4 py-2 shadow-xs"
                onClick={() => onExampleClick(val)}
              >
                {val}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EmptyChat;
